import { render, staticRenderFns } from "./Axes.vue?vue&type=template&id=3e1283b2&scoped=true&"
var script = {}
import style0 from "./Axes.vue?vue&type=style&index=0&id=3e1283b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1283b2",
  null
  
)

export default component.exports